module.exports = __webpack_public_path__ + "img/sbtn2.d0d7b0eb.png";